import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fmtUSD } from "../lib/api";
import { ArrowUpRight } from "lucide-react";

// Rotate pastel tile colors across the catalog so the product grid feels lively.
const TILES = ["tile-pink", "tile-blue", "tile-green", "tile-lavender", "tile-cream"];

// Products that have multiple strength variants — overrides the strength label
// shown in the catalog so customers know more sizes are available on the page.
const VARIANT_STRENGTH_LABELS = {
    "glp-3r-10mg": "10 / 30 mg",
};

export default function ProductCard({ product, index = 0 }) {
    const tile = TILES[index % TILES.length];
    const strengthLabel = VARIANT_STRENGTH_LABELS[product.slug] || product.strength;
    return (
        <Link
            to={`/product/${product.slug}`}
            data-testid={`product-card-${product.slug}`}
            className="card card-hover group block reveal overflow-hidden"
            style={{ animationDelay: `${index * 60}ms` }}
        >
            <div className={`relative aspect-[5/4] ${tile} overflow-hidden flex items-center justify-center p-8`}>
                <img
                    src={product.image}
                    alt={product.name}
                    loading="lazy"
                    className="max-h-[78%] max-w-[50%] object-contain transition-transform duration-700 group-hover:scale-110"
                    style={{ filter: "drop-shadow(0 20px 30px rgba(15, 23, 42, 0.22))" }}
                />
                {product.is_featured && (
                    <span className="absolute top-3 right-3 pill pill-dark">FEATURED</span>
                )}
                <span className="absolute top-3 left-3 pill">≥99% PURITY</span>
            </div>
            <div className="p-6">
                <div className="flex items-baseline justify-between mb-1">
                    <h3 className="font-display text-2xl text-[var(--text-primary)] leading-none">{product.name}</h3>
                    <div className="font-ui font-medium text-xs text-secondary">{strengthLabel}</div>
                </div>
                <div className="data-label mb-3">{product.category}</div>
                <p className="text-sm text-secondary line-clamp-2 mb-5 leading-relaxed">{product.short_description}</p>
                <div className="flex items-center justify-between pt-4 border-t border-[var(--border)]">
                    <div className="font-display text-xl text-[var(--text-primary)]">{fmtUSD(product.price)}</div>
                    <span className="font-ui font-medium text-xs text-[var(--brand)] flex items-center gap-1 group-hover:gap-2 transition-all">
                        View <ArrowUpRight size={14} />
                    </span>
                </div>
            </div>
        </Link>
    );
}
